<template>
  <span class="text-20px lt-mobile:text-14px text-text-green"><slot /></span>
</template>
